import sanitizeHtml from 'sanitize-html';

const SANITIZE_OPTIONS = {
  allowedTags: ['b', 'strong', 'i', 'em', 'u', 'font', 'a', 'br'],
  allowedAttributes: {
    a: ['href'],
    font: ['color', 'face', 'size'],
  },
  allowedSchemes: ['http', 'https'],
  disallowedTagsMode: 'discard',
  selfClosing: ['br'],
};

// sanitize-html always serializes void elements as `<br />`. Profiles are
// capped at PROFILE_MAX_LENGTH, so emit the 4-character `<br>` form instead and
// give that budget back to the user. Note that dropping 'br' from `selfClosing`
// is not an alternative: it emits `<br></br>`, which browsers parse as two
// breaks.
function compactBreaks(html) {
  return html.replace(/<br\s*\/>/g, '<br>');
}

export function sanitizeProfile(html) {
  return compactBreaks(sanitizeHtml(html, SANITIZE_OPTIONS));
}
